function replaceHref() {
  // Header links with class 'mgp-upcase'
  const headerLinks = document.querySelectorAll('li a.mgp-upcase');
  headerLinks.forEach(link => {
    if (link.getAttribute('href') === '/pages/contact-us') {
      link.setAttribute('href', 'JavaScript:openMavenoid()');
    }
  });

  // Footer links with class 'mgp-upcase-footer'
  const footerLinks = document.querySelectorAll('li a.mgp-upcase-footer');
  footerLinks.forEach(link => {
    if (link.getAttribute('href') === '/pages/contact-us') {
      link.setAttribute('href', 'JavaScript:openMavenoid()');
    }
  });
}

document.addEventListener('DOMContentLoaded', () => {
  replaceHref();
});
